import React from "react"

import PropTypes from "prop-types"

import * as styles from "./newsletter-intro.module.scss"
import Button from "../../atoms/button"
import CopyContainer from "../../atoms/copy-container"
import Heading from "../../atoms/heading"

const NewsletterIntro = ({ section }) => (
  <div className={styles.wrapper}>
    <CopyContainer>
      <Heading level={4} className={styles.title}>
        {section.title}
      </Heading>
      <CopyContainer content={section._rawContent} />
    </CopyContainer>
    {section.has_cta ? (
      <Button
        className={`${styles.button}  ${styles[`button__${section.cta_color.replaceAll("-", "")}`]}`}
        url={section.cta_url}
      >
        {section.cta_text}
      </Button>
    ) : (
      ""
    )}
  </div>
)

export default NewsletterIntro

NewsletterIntro.propTypes = {
  section: PropTypes.object.isRequired,
}
